<main>
  <!-- List Details -->
  <div *ngIf="!viewMode">
    <div class="school-head flex-wrap gap-2">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
        <div class="header-text school-text">School management</div>
      </div>
      <div class="d-flex gap-3 align-items-center flex-wrap">
        <!-- <div> -->
        <div class="search-container">
          <div class="search-icon">
            <img
              src="assets/icons/side-bar/search-normal.svg"
              alt="search"
              style="width: 18px; height: 18px"
            />
          </div>
          <input
            type="text"
            placeholder="Search here..."
            class="search-input"
            [(ngModel)]="search"
            (input)="updateSearch(search)"
            autocomplete="off"
          />
        </div>
        <!-- </div> -->
        <app-button
          label="Add new school"
          *ngIf="userRoles.addNew"
          minWidth="12.125rem"
          (clicked)="openAddSchoolDialog()"
        ></app-button>

        <app-export-dropdown
          label="Export"
          *ngIf="userRoles.export"
          [apiWise]="true"
          [exportApiUrl]="getExportApiUrl()"
          [tableName]="'Schools'"
          [currentParams]="getCurrentExportParams()"
          [isSearch]="!!search"
          (export)="onExportComplete($event)"
        >
        </app-export-dropdown>
      </div>
    </div>

    <div>
      <div class="table-card">
        <app-table
          [columns]="columns"
          [data]="data"
          [actionTemplate]="actionButtonsTemplate"
          [loading]="loading"
          (rowClick)="onView($event)"
          (statusClick)="onStatusUpdate($event)"
          tableName="School management"
          [totalItems]="totalRecords"
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (pageChange)="onPageChange($event)"
          (sortClick)="onSort($event)"
          [serverSidePagination]="true"
        >
        </app-table>
      </div>
    </div>
  </div>

  <ng-template #schoolDetailsDialog>
    <div class="dialog-content school-dialog-content p-4">
      <div class="d-flex justify-content-between align-items-center mb-3 gap-3">
        <div class="header-text school-text">School details</div>
        <button
          type="button"
          mat-dialog-close
          class="dialog-close-button"
        >
          Close
        </button>
      </div>

      <div class="school-details">
        <div class="d-flex justify-content-between d-flex gap-2 flex-wrap">
          <div class="d-flex align-items-center gap-3">
            <img
              class="school-img"
              src="../../../assets/images/student_school.svg"
            />
            <div class="text-head">{{ selectedSchool?.schoolName }}</div>
          </div>
          <div
            *ngIf="userRoles.listItem.edit"
            class="edit-button"
            (click)="onEdit(selectedSchool)"
          >
            <img
              alt="edit"
              class="edit-img"
              src="assets/images/Buttons/edit-button.svg"
            />
          </div>
        </div>

        <div class="details-section">
          <div class="d-grid gap-2">
            <div class="main-text">School type</div>
            <div class="secondary-text">
              {{ selectedSchool?.schoolTypeName }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="main-text">Location/Address</div>
            <div class="secondary-text">
              {{ formatSchoolAddress(selectedSchool) }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="main-text">Partnership status</div>
            <div class="secondary-text">
              {{ selectedSchool?.isMouSchool ? "Partnership School" : "Non-Partnership School" }}
            </div>
          </div>
        </div>

        <div class="details-section">
          <div class="d-grid gap-2 w-100">
            <div class="main-text">Partnership contact details</div>
            <div class="secondary-text" *ngIf="contactData.length === 0">
              No contact details available
            </div>
            <div class="secondary-text" *ngFor="let contact of contactData">
              {{ formatContactSummary(contact) }}
            </div>
          </div>
        </div>
      </div>

      <div class="table-details mt-4">
        <div class="settings-bg">
          <div
            class="d-flex justify-content-between align-items-center gap-3 mb-3"
          >
            <div class="header-text school-text">Associated teachers</div>
            <button
              class="dialog-add-button"
              *ngIf="userViewRoles.addItem || userRoles.addNew"
              (click)="openAddTeacherDialog()"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
              />
              Add teacher
            </button>
          </div>

          <app-table
            [columns]="teachercolumns"
            [data]="teacherData"
            [loading]="loading"
            [actionTemplate]="actionButtonsTeacher"
          >
          </app-table>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- View Details -->
  <div
    *ngIf="viewMode && selectedSchoolID"
    class="school-view-page d-flex flex-column gap-4"
  >
    <div
      class="school-back-link d-flex align-items-center gap-3 flex-wrap"
      style="cursor: pointer"
      (click)="goBack()"
    >
      <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
      <div class="header-text school-text">Back to School</div>
    </div>

    <div class="school-details school-view-card">
      <div class="d-flex justify-content-between d-flex gap-2">
        <div class="d-flex align-items-center gap-3">
          <img
            class="school-img"
            src="../../../assets/images/student_school.svg"
          />
          <div class="text-head">{{ selectedSchool?.schoolName }}</div>
        </div>
        <div
          *ngIf="userViewRoles.edit"
          class="edit-button"
          (click)="onEdit(selectedSchool)"
        >
          <img
            alt="edit"
            class="edit-img"
            src="assets/images/Buttons/edit-button.svg"
          />
        </div>
      </div>

      <div class="details-section">
        <div class="d-grid gap-2">
          <div class="main-text">School type</div>
          <div class="secondary-text">{{ selectedSchool?.schoolTypeName }}</div>
        </div>

        <div class="d-grid gap-2">
          <div class="main-text">Address</div>
          <div class="secondary-text">{{ selectedSchool?.address }}</div>
        </div>
        
        <div class="d-grid gap-2">
          <div class="main-text">Suburb</div>
          <div class="secondary-text">{{ selectedSchool?.suburb }}</div>
        </div>
        <!-- <div class="d-grid gap-2">
          <div class="main-text">
            Partnership School/s / Non-Partnership School/s
          </div>
          <div class="secondary-text">
            {{
              selectedSchool?.isMouSchool
                ? "Partnership School/s"
                : "Non-Partnership School/s"
            }}
          </div>
        </div> -->
      </div>

      <div class="details-section">
        <div class="d-grid gap-2">
          <div class="main-text">Postcode</div>
          <div class="secondary-text">{{ selectedSchool?.postcode }}</div>
        </div>
        <div class="d-grid gap-2">
          <div class="main-text">Region</div>
          <div class="secondary-text">{{ selectedSchool?.regionName }}</div>
        </div>
        <div class="d-grid gap-2">
          <div class="main-text">State</div>
          <div class="secondary-text">{{ selectedSchool?.state }}</div>
        </div>
      </div>
    </div>

    <div class="table-details school-view-table">
      <div class="settings-bg school-view-settings">
        <div class="d-flex justify-content-between button-container">
          <div class="segment-buttons">
            <button
              [disabled]="selectedSegment === 'teachers'"
              [class.active]="selectedSegment === 'teachers'"
              (click)="switchSegment('teachers')"
            >
              Teachers
            </button>
            <button
              [disabled]="selectedSegment === 'students'"
              [class.active]="selectedSegment === 'students'"
              (click)="switchSegment('students')"
            >
              Students
            </button>
            <button
              [disabled]="selectedSegment === 'contacts'"
              [class.active]="selectedSegment === 'contacts'"
              (click)="switchSegment('contacts')"
            >
              Contact details
            </button>
          </div>
          <div class="add-buttons" *ngIf="userViewRoles.addItem">
            <button
              *ngIf="selectedSegment === 'teachers'"
              (click)="openAddTeacherDialog()"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
              />
              Add teacher
            </button>
            <button
              *ngIf="selectedSegment === 'students'"
              (click)="openAddStudentDialog()"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
              />
              Add student
            </button>
            <button
              *ngIf="selectedSegment === 'contacts'"
              (click)="openAddContactDialog()"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
              />
              Add contact
            </button>
          </div>
        </div>

        <div class="table-page">
          <!-- <div *ngIf="selectedSegment === 'teachers'"> -->
          <app-table
            *ngIf="selectedSegment === 'teachers'"
            [columns]="teachercolumns"
            [data]="teacherData"
            [loading]="loading"
            [actionTemplate]="actionButtonsTeacher"
          >
          </app-table>
          <!-- </div> -->
          <!-- <div *ngIf="selectedSegment === 'students'"> -->
          <app-table
            *ngIf="selectedSegment === 'students'"
            [columns]="studentcolumns"
            [data]="studentData"
            [loading]="loading"
            [actionTemplate]="actionButtonsStudent"
          >
          </app-table>
          <!-- </div> -->
          <!-- <div *ngIf="selectedSegment === 'contacts'"> -->
          <app-table
            *ngIf="selectedSegment === 'contacts'"
            [columns]="contactcolumns"
            [data]="contactData"
            [loading]="loading"
            [actionTemplate]="actionButtonsContact"
          >
          </app-table>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template #actionButtons let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      *ngIf="userRoles.listItem.view"
      (click)="onView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
    <img
      class="action-button"
      *ngIf="userRoles.listItem.edit"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
    <img
      class="action-button"
      *ngIf="userRoles.listItem.delete"
      (click)="onDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>

<ng-template #actionButtonsTeacher let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.view"
      (click)="onTeacherView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.edit"
      (click)="onTeacherEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.delete"
      (click)="onTeacherDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>

<ng-template #actionButtonsStudent let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.view"
      (click)="onStudentView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.edit"
      (click)="onStudentEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.delete"
      (click)="onStudentDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>

<ng-template #actionButtonsContact let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <!-- <img class="action-button" (click)="onContactView(row)" src="assets/images/Buttons/view-button.svg"
            alt="View" /> -->
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.edit"
      (click)="onContactEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="View"
    />
    <img
      class="action-button"
      *ngIf="userViewRoles.listItem.delete"
      (click)="onDeleteConatct(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>
